// extracted by mini-css-extract-plugin
export var active = "styles-module--active--6b229";
export var container = "styles-module--container--88e30";
export var dark = "styles-module--dark--12750";
export var stretch = "styles-module--stretch--6c538";
export var tab = "styles-module--tab--a2814";
export var tabs = "styles-module--tabs--232c2";